import React from 'react';
import { Table } from 'react-bootstrap';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import "./Fees.css"
const Fees = () => {
  const Checking = [
    { AccountType: 'Checking', Minimum : '$100', Fee: '$0' },
  
  ];


  const Business = [
    { AccountType: 'Small Business Checking', Minimum : '$100', Fee: '$25' },
  
  ];


  const Savings = [
    { AccountType: 'Statement Savings ', Minimum:'$250.00', Fee: '$15.00**', Rate:"0.010%" },
    { AccountType: 'MMDA', Minimum: '$2,500.00', Fee: '$15.00**', Rate:"0.030%" },
    {AccountType: "Promotional Savings", Minimum: "$2,500.00", Fee: "$15.00**", Rate: "3.6%"}
  
  ];


  const Services = [
    { FeesType: 'ATM Cash Withdrawal Fees ', Desc:'$3.00 per each transactions for non GN Bank customers.' },
    { FeesType: 'Change your ATM Card Personal Identification Number (PIN) ', Desc:'$5.00 per change request/ Free at GN Bank ATM' },
    // { FeesType: 'Replace a lost ATM / Debit Card', Desc:'$15.00 per card' },
    // { FeesType: 'Foreign ATM ', Desc:'$15.00 per card' }

  ];




  const Overdraft = [
    { FeesType: 'Occurs when GN Bank pays for a transaction (including ACH transactions) when your account does not have enough funds.', title:"Non-Sufficient Funds Fee" , Desc:"$35.00 per transaction(current fee) "},
    { FeesType: 'Occurs for any check or ACH transaction that GN Bank returns unpaid due to insufficient funds in an account', title:"Returned Item Fee" , Desc:"$35.00 per transaction(current fee) "},
    { FeesType: '*The Extended overdrawn Account Fee is charged daily for each day the account remains overdrawn. Please enroll in online banking and monitor your account balance closely*', title:"Extended Overdrawn Account Fee" , Desc:"$35.00 per transfer(Effective September 16, 019)"},
    { FeesType: 'Occurs when there are excessive transactions of the six transfer/withdrawal limitations (Excessive transactions are transfers and/or withdrawals)', title:"Savings Account Fee" , Desc:"$3.00 per transfer transaction(Effective September 16, 2019) "}

  ];



  const Dormant = [
    { FeesType: 'A Checking, MMDA, or NOW account is dormant if for twelve months you have made no deposits or withdrawals to the account and you have had no communication with us about your account(s).A Savings account is dormant if for six months you have made no deposits or withdrawals to the account and you have no communication with us about your account(s)', title:"Dormant Account Fee" , Desc:"$15.00 per month for each dormant account "},
 


  ];


  
  const CheckingFees = [
    // { FeesType: 'Account History Printout', Desc:'$3.00 per copy', info:"" },
    { FeesType: 'Check Printing', Desc:'Fee varies based on style of check',info:""  },
    // { FeesType: 'Copy of Cancelled Check', Desc:'$5.00 per copy',info:""  },
    // { FeesType: 'Copy of Cancelled Withdrawal Check ', Desc:'$5.00 per copy',info:""  },
    // { FeesType: 'Deposit Verifcation Statement ', Desc:'$10.00 per statement',info:""  },
    { FeesType: 'Duplicate Account Statement ', Desc:'$8.00 per statement',info:""  },
    { FeesType: 'Stop Payments Fee ', Desc:'$35.00 per request', info:"Occurs when you make a stop payment request for a check, ACH, or electronic payment"  },
    // { FeesType: 'Account Closed within 90 days of Opening Fee ', Desc:'$15.00 per prematurely closed account', info:"Occurs when you close a new checking account within 90 days of opening it"  },
    

  ];

  const Document = [

    // { "description": "Fax Fee - local", "amount": "$1.00 per page" },
        // { "description": "Fax Fee - long distance", "amount": "$5.00 per page" },
        { "description": "Immigration Letters", "amount": "$10.00 per letter" },
        { "description": "Official Bank Checks - first check", "amount": " **fee varies based on the type of check " },
        // { "description": "Official Bank Checks - additional", "amount": "$1.00 per additional check (in that month)" },
        // { "description": "Photocopies", "amount": "$0.50 per copy" },
        // { "description": "Temporary Checks", "amount": "$1.00 for five checks" },
        { "description": "Cashier's Checks", "amount": "$3.00 for checks up to $500.00" }
    
    
    
  ]



  const BusinessAccountFees = [

    { "description": "Audit Confirmation", "amount": "$10.00 per confirmation" },
        { "description": "Signature Guarantee", "amount": "$2.00 per guarantee" }
  ]

  const legal = [
    { "description": "Garnishment Processing", "amount": "$100.00 per garnishment" },
    { "description": "Levies, Subpoena, and other Legal Services", "amount": "$100.00 per service" }
  ]


  const TransferFees = [

    { "description": "Outgoing Domestic Wire Transfer", "amount": "$30.00 per transfer", info:"Send a wire to a bank account in the United States" },
    { "description": "Incoming Wire Transfer", "amount": "$15.00 per transfer",info:"Wire deposited into your account"  },
    { "description": "Customer Direct Transfer", "amount": "$10.00 per transfer",info:""  },
    // { "description": "Internal Transfers", "amount": "$2.00 per transfer",info:""  }
  ]

  const PromotionAndSavings = [

    {
      "description": "*Promotional Savings Rate",
      "amount": "GN Bank Promotional Savings Rate is 3.6%. *Promotional Savings Rate increases or decreases in line with rate guidance from the Federal Reserve."
    }

  ]


  const otherFees = [


    
      {
        "description": "Non-Customer Check Cashing Fee",
        "amount": "GN Bank does not cash checks for non-customers"
      },
      {
        "description": "Coin Counting / Redemption",
        "amount": "GN Bank Customers Only"
      },
      { "description": "Rolled Coin Purchase", "amount": "$0.10 per roll" },
      {
        "description": "Debit Card or ACH Fraud Activity Claim",
        "info":"Occurs when you request GN Bank to look into fraudulent activity on your account",
        "amount": "$25.00 per hour ($15.00 minimum)"
      },
      {
        "description": "Research Fee",
        "info": "Occurs for research done regarding your accounts and/or loans	",
        "amount": "$250.00 per hour ($150.00 minimum)"
      },
      { "description": "Notary Public", "amount": "$5.00" , "info": "Occurs when you request a witness for signatures"},

      { "description": "Foreign ATM Fees", "amount": "$4.00" }
    
  ]


  













  return (

    <div>
    {/* Hero Section */}
    <section className="hero-sections-fees text-center text-white py-5">
      <Container>
        <p className='h1 mt-4 gn-title'>Fees</p>
        <p className="lead gn-secondary-title">
Below are our rates and Charges.
        </p>
        {/* <Button variant="light" size="lg" className='bg-button gn-button'>
          Compare All Cards
        </Button> */}
      </Container>
    </section>
    <div className="container my-5">
      <h2 className="gn-title h3 mb-4">Personal Checking</h2>
      <p className="text-muted">
        Secure your savings with competitive rates and flexible terms.
      </p>
      <Table responsive="sm" bordered className="text-center">
      <colgroup>
        
        <col width="30%"/>
        <col width="30%"/>
        <col width="30%"/>
        
        </colgroup>
        <thead>
          <tr>
            {/* <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th> */}

            <th scope='col' className='h5'>Account Type</th>
            <th scope='col' className='h5'>Minimum Balance to Open </th>
            <th scope='col' className='h5'>Monthly Maintenance Fee</th>
            
          </tr>
        </thead>
        <tbody>
          {Checking.map((cd, index) => (
            <tr key={index}>
              <td>{cd.AccountType}</td>
              <td>{cd.Minimum}</td>
              <td>{cd.Fee}</td>
            </tr>
          ))}
        </tbody>
      </Table>

<ul className="account-notes">
<li>*Monthly maintenance fee waived for Retail Checking with a $100 daily balance.</li>
{/* <li>Fee waived for Renaissance Checking with a $10 daily balance.</li>
<li>**Renaissance Checking requires qualifying direct deposit.</li> */}


</ul>
      







    </div>




    <div className="container my-5">
      <h2 className="mb-4 h3 gn-title">Business Checking</h2>
      <p className="text-muted">
        Secure your savings with competitive rates and flexible terms.
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
      <colgroup>
        
        <col width="30%"/>
        <col width="30%"/>
        <col width="30%"/>
        
        </colgroup>
        <thead>
          <tr>
            {/* <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th> */}

            <th scope='col' className='h5'>Account Type</th>
            <th scope='col' className='h5'>Minimum Balance to Open </th>
            <th scope='col' className='h5'>Monthly Maintenance Fee</th>
            
          </tr>
        </thead>
        <tbody>
          {Business.map((cd, index) => (
            <tr key={index}>
              <td>{cd.AccountType}</td>
              <td>{cd.Minimum}</td>
              <td>{cd.Fee}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ul className="account-notes">
<li>*Monthly maintenance fee is waived if the minimum account balance is at least $3,000</li>
{/* <li>Fee waived for Renaissance Checking with a $10 daily balance.</li>
<li>**Renaissance Checking requires qualifying direct deposit.</li> */}


</ul>
    </div>












    <div className="container my-5">
      <h2 className="mb-4 gn-title h3">Personal Savings</h2>
      {/* <p className="text-center text-muted">
        Secure your savings with competitive rates and flexible terms.
      </p> */}
      <Table responsive="sm"  className="text-center"  bordered striped>
        {/* <thead>
          <tr>
            <th>Account Type</th>
            <th>Minimum Balance to Open </th>
            <th>Monthly Maintenance Fee</th>
          </tr>
        </thead> */}



        <colgroup>
        
        <col width="25%"/>
        <col width="25%"/>
        <col width="25%"/>
        <col width="25%"/>
        </colgroup>
        <thead>
          <tr>
            {/* <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th> */}

            <th scope='col' className='h5'>Account Type</th>
            <th scope='col' className='h5'>Minimum Balance to Open </th>
            <th scope='col' className='h5'>Monthly Maintenance Fee</th>
             <th scope='col' className='h5'>Rate</th>
          </tr>
        </thead>




        <tbody>
          {Savings.map((cd, index) => (
            <tr key={index}>
              <td>{cd.AccountType}</td>
              <td className='mx-auto'><section className='text-justify'> {cd.Minimum}</section></td>
              <td>{cd.Fee}</td>
               <td>{cd.Rate}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ul className="account-notes">
<li>*Monthly maintenance fee is waived for each account if minimum account balance is maintained</li>
<li>**For Statement savings minimum account balance of $500 is required to qualify for Statement Savings interest</li>
<li>**For MMDA Savings  minimum account balance of $2500 is required to qualify for MMDA Savings interest</li>

</ul>
    </div>







    <div className="container my-5">
      <h2 className="mb-4 gn-title h3">ATM/Debit Card Fees</h2>
     
      <Table responsive="sm"  className="text-center"  bordered striped>
      <colgroup>
        
        <col width="50%"/>
        <col width="50%"/>
        
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th>
            
          </tr>
        </thead>
        <tbody>
          {Services.map((cd, index) => (
            <tr key={index}>
              <td><p>{cd.FeesType}</p></td>
              <td className=''><p>{cd.Desc}</p></td>
              {/* <td>{cd.Fee}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>








    <div className="container my-5">
      <h2 className="mb-4 gn-title h3">OverDraft Charges </h2>
      <p className="text-center text-muted">
        {/* Service Charges */}
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
      <colgroup>
        
        <col width="50%"/>
        <col width="50%"/>
        
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th>
            
          </tr>
        </thead>
        <tbody>
          {Overdraft.map((cd, index) => (
            <tr key={index}>
              <td> <p>{cd.title}</p><p>{cd.FeesType}</p></td>
              <td className=''><p>{cd.Desc}</p></td>
              {/* <td>{cd.Fee}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>





    <div className="container my-5">
      <h2 className=" mb-4 gn-title h3">Dormant Account Charges </h2>
      <p className="text-center text-muted">
        {/* Service Charges */}
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
      <colgroup>
        
        <col width="50%"/>
        <col width="50%"/>
        
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th>
            
          </tr>
        </thead>
        <tbody>
          {Dormant.map((cd, index) => (
            <tr key={index}>
              <td> <p>{cd.title}</p><p>{cd.FeesType}</p></td>
              <td className=''><p>{cd.Desc}</p></td>
              {/* <td>{cd.Fee}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>





    <div className="container my-5">
      <h2 className=" gn-title mb-4 h3">Checking Account Charges </h2>
      <p className="text-center text-muted">
        {/* Service Charges */}
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
      <colgroup>
        
        <col width="50%"/>
        <col width="50%"/>
        
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th>
            
          </tr>
        </thead>
        <tbody>
          {CheckingFees.map((cd, index) => (
            <tr key={index}>
              <td> <p>{cd.title}</p><p>{cd.FeesType}
                    <p><strong>{cd.info}</strong></p>
                </p></td>
              <td className=''><p>{cd.Desc}
            
                </p></td>
              {/* <td>{cd.Fee}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>





    <div className="container my-5">
      <h2 className=" gn-title mb-4 h3">Checking Account Charges </h2>
      <p className="text-center text-muted">
        {/* Service Charges */}
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
      <colgroup>
        
        <col width="50%"/>
        <col width="50%"/>
        
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th>
            
          </tr>
        </thead>
        <tbody>
          {CheckingFees.map((cd, index) => (
            <tr key={index}>
              <td> <p>{cd.title}</p><p>{cd.FeesType}
                    <p><strong>{cd.info}</strong></p>
                </p></td>
              <td className=''><p>{cd.Desc}
            
                </p></td>
              {/* <td>{cd.Fee}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>




    <div className="container my-5">
      <h2 className=" gn-title mb-4 h3">Document Fees </h2>
      <p className="text-center text-muted">
        {/* Service Charges */}
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
      <colgroup>
        
        <col width="50%"/>
        <col width="50%"/>
        
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th>
            
          </tr>
        </thead>
        <tbody>
          {Document.map((cd, index) => (
            <tr key={index}>
              <td> <p>{cd.description}</p><p>{cd.info}
                    <p><strong>{cd.info}</strong></p>
                </p></td>
              <td className=''><p>{cd.amount}
            
                </p></td>
              {/* <td>{cd.Fee}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>





    <div className="container my-5">
      <h2 className=" gn-title mb-4 h3">Business Account Charges </h2>
      <p className="text-center text-muted">
        {/* Service Charges */}
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
      <colgroup>
        
        <col width="50%"/>
        <col width="50%"/>
        
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th>
            
          </tr>
        </thead>
        <tbody>
          {BusinessAccountFees.map((cd, index) => (
            <tr key={index}>
              <td> <p>{cd.description}</p><p>{cd.info}
                    <p><strong>{cd.info}</strong></p>
                </p></td>
              <td className=''><p>{cd.amount}
            
                </p></td>
              {/* <td>{cd.Fee}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>




    <div className="container my-5">
      <h3 className=" gn-title mb-4 h3">Legal Fees </h3>
      <p className="text-center text-muted">
        {/* Service Charges */}
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
        {/* <thead>
          <tr>
            <th className='h3'>Legal Fees</th>
            <th> </th>
            
          </tr>
        </thead> */}


<colgroup>
        
        <col width="50%"/>
        <col width="50%"/>
        
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th>
            
          </tr>
        </thead>



        <tbody>
          {legal.map((cd, index) => (
            <tr key={index}>
              <td> <p>{cd.description}</p><p>{cd.info}
                    <p><strong>{cd.info}</strong></p>
                </p></td>
              <td className=''><p>{cd.amount}
            
                </p></td>
              {/* <td>{cd.Fee}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>




    <div className="container my-5">
      <h2 className=" gn-title mb-4 h2">Transfer Fees </h2>
      <p className="text-center text-muted">
        {/* Service Charges */}
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
{/* 
      <h2 className="text-center mb-4 gn-title h3">Transfer Fees</h2> */}

        <colgroup>
        
        <col width="50%"/>
        <col width="50%"/>
        
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th>
            
          </tr>
        </thead>
        <tbody>
          {TransferFees.map((cd, index) => (
            <tr key={index}>
              <td> <p>{cd.description}</p><p>{cd.info}
                    <p>
                      </p>
                </p></td>
              <td className=''><p>{cd.amount}
            
                </p></td>
              {/* <td>{cd.Fee}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>






    <div className="container my-5">
      <h2 className=" gn-title mb-4 h2">Savings & Promotional </h2>
      <p className="text-center text-muted">
        {/* Service Charges */}
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
        {/* <thead>
          <tr>
            <th className='h5'>Savings And Promotional</th>
            <th> </th>
            
          </tr>
        </thead> */}





        <colgroup>
        
        <col width="50%"/>
        <col width="50%"/>
        
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th>
            
          </tr>
        </thead>




        <tbody>
          {PromotionAndSavings.map((cd, index) => (
            <tr key={index}>
              <td> <p>{cd.description}</p><p>{cd.info}
                    <p><strong>{cd.info}</strong></p>
                </p></td>
              <td className=''><p>{cd.amount}
            
                </p></td>
              {/* <td>{cd.Fee}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>





    <div className="container my-5">
      <h3 className=" gn-title mb-4 h3">Other/Miscellaneous Fees</h3>
      <p className="text-center text-muted">
        {/* Service Charges */}
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
        {/* <thead>
          <tr>
            <th className='h4'>Other/Miscellaneous Fees</th>
            <th> </th>
            
          </tr>
        </thead> */}


<colgroup>
        
        <col width="50%"/>
        <col width="50%"/>
        
        </colgroup>
        <thead>
          <tr>
            <th scope='col' className='h5'>Service</th>
            <th scope="col" className='h5'>  Fees</th>
            
          </tr>
        </thead>


        <tbody>
          {otherFees.map((cd, index) => (
            <tr key={index}>
              <td> <p>{cd.description}</p><p><strong>{cd.info}</strong></p>
                </td>
              <td className=''><p>{cd.amount}</p></td>
              {/* <td>{cd.Fee}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>




    <div className="container my-5">
      {/* <h2 className=" gn-title mb-4 h2">Checking Account Charges </h2> */}
      <p className="text-center text-muted">
        {/* Service Charges */}
      </p>
      <Table responsive="sm"  className="text-center"  bordered striped>
        {/* <thead>
          <tr>
            <th className='h4'>Other/Miscellaneous Fees</th>
            <th> </th>
            
          </tr>
        </thead> */}
        <tbody>
        
        <div>
<h2 className='gn-title justify-content-start d-flex'>CHECK ACCEPTANCE NOTICE</h2>
<p>Starting September 16, 2019 GN Bank will no longer be accepting checks with the previous name of Illinois Service Federal Savings & Loan Association AKA ISF Bank. If you have checks with this branding on them please bring them to your local branch location so that new checks can be ordered. New Checks can be ordered at no cost to you if brought in before September 16, 2019. Anything after September 16, 2019 will be normal charges on the order of checks.

For more information about service charges, feel free to contact your local GN Bank branch.</p>


</div>
        </tbody>
      </Table>
    </div>






    </div>
  );
};

export default Fees;
